<div class="tp-wrapper">
  <table class="tp-table">
    <thead class="tp-header">
    <tr>
      <th class="tp-header-cell">
          <span class="tp-header-content">
            <mat-icon aria-hidden="false" aria-label="Icono paciente" svgIcon="avatar-contrast"></mat-icon>
            <span class="tp-header-text">Nombre</span>
          </span>
      </th>
      <th class="tp-header-cell tp-text-center">
          <span class="tp-header-content">
            <mat-icon aria-hidden="false" aria-label="Icono documento" svgIcon="badge"></mat-icon>
            <span class="tp-header-text">N° Documento</span>
          </span>
      </th>
      <th class="tp-header-cell tp-text-center">
          <span class="tp-header-content">
            <mat-icon aria-hidden="false" aria-label="Icono calendario" svgIcon="calendar-info-consulta"></mat-icon>
            <span class="tp-header-text">Última consulta</span>
          </span>
      </th>
      <th class="tp-header-cell tp-text-center">
          <span class="tp-header-content">
            <mat-icon aria-hidden="false" aria-label="Icono historial" svgIcon="health-contrast"></mat-icon>
            <span class="tp-header-text">Ficha clínica</span>
          </span>
      </th>
    </tr>
    </thead>

    <tbody>
      @for ( patient of patients(); track patient.id ) {
        <tr class="tp-row-divider tp-last-row-no-divider">
          <td class="tp-cell">
            {{ patient.completeName }}
          </td>

          <td class="tp-cell tp-text-center">
            {{ patient.documentNumber }}
          </td>

          <td class="tp-cell tp-text-center">
            {{ patient.date | date:'dd/MM/yyyy' }}
          </td>

          <td class="tp-cell tp-text-center">
            <span class="tp-button-container">
              <img src="assets/icons/eye_outline.svg" alt="Ícono ojo" class="tp-icon-sm" />
              <span class="tp-link-text" (click)="onPatientHistoryClick(patient)">
                Ver Historial
              </span>
            </span>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
